export const timelineData = {
    periods: [
        {
            id: 1,
            title: 'Технологии',
            startYear: 1980,
            endYear: 1986,
            events: [
                {
                    year: 1980,
                    title: 'Создание первого персонального компьютера IBM выпустила свой первый персональный компьютер IBM PC'
                },
                {
                    year: 1981,
                    title: 'Появление MS-DOS Microsoft выпустила операционную систему MS-DOS'
                },
                {
                    year: 1983,
                    title: 'Интернет протокол TCP/IP Стандартизация протокола TCP/IP для сети ARPANET'
                },
                { year: 1984, title: 'Apple Macintosh Презентация Macintosh с графическим интерфейсом' },
                { year: 1985, title: 'Windows 1.0 Microsoft представляет первую версию Windows' }
            ]
        },
        {
            id: 2,
            title: 'Кино',
            startYear: 1987,
            endYear: 1991,
            events: [
                {
                    year: 1987,
                    title: 'Выход фильма "Хищник" Арнольд Шварценеггер в роли майора Датча Шеффера'
                },
                {
                    year: 1989,
                    title: 'Бэтмен Тима Бертона Майкл Китон в роли Бэтмена, Джек Николсон в роли Джокера'
                },
                {
                    year: 1991,
                    title: 'Терминатор 2 Продолжение культовой франшизы с революционными спецэффектами'
                },
                { year: 1991, title: 'Терминатор 2 Революция в использовании CGI эффектов' },
                { year: 1991, title: 'Молчание ягнят Фильм получает пять основных Оскаров' }
            ]
        },
        {
            id: 3,
            title: 'Литература',
            startYear: 1992,
            endYear: 1997,
            events: [
                {
                    year: 1992,
                    title: 'Публикация романа "Игра престолов" Джордж Мартин начал серию "Песнь льда и пламени"'
                },
                {
                    year: 1995,
                    title: 'Выход "Гарри Поттера" Дж. К. Роулинг опубликовала первую книгу о юном волшебнике'
                },
                {
                    year: 1997,
                    title: 'Нобелевская премия Дарио Фо Итальянский драматург получил Нобелевскую премию по литературе'
                }
            ]
        },
        {
            id: 4,
            title: 'Театр',
            startYear: 1999,
            endYear: 2004,
            events: [
                {
                    year: 1999,
                    title: 'Премьера мюзикла "Мамма Миа!" Мюзикл на песни группы ABBA дебютировал в Лондоне'
                },
                {
                    year: 2001,
                    title: 'Открытие нового театра В Москве открылся Театр Наций'
                },
                { year: 2002, title: 'Современная режиссура Рост экспериментальных постановок' },
                {
                    year: 2003,
                    title: 'Премьера "Продюсеров" Мюзикл Мела Брукса стал хитом Бродвея'
                },
                { year: 2004, title: 'Цифровые технологии Видеопроекции на театральной сцене' }
            ]
        },
        {
            id: 5,
            title: 'Спорт',
            startYear: 2006,
            endYear: 2014,
            events: [
                {
                    year: 2006,
                    title: 'Чемпионат мира по футболу в Германии – Италия выигрывает в финале у Франции'
                },
                {
                    year: 2008,
                    title: 'Олимпиада в Пекине XXIX летние Олимпийские игры в Китае'
                },
                {
                    year: 2009,
                    title: 'Формула-1: Джейксон Алонсо становится чемпионом мира'
                },
                {
                    year: 2010,
                    title: 'Чемпионат мира по футболу Первый чемпионат мира по футболу в Африке (ЮАР)'
                },
                {
                    year: 2012,
                    title: 'Олимпиада в Лондоне XXX летние Олимпийские игры в Великобритании'
                },
                {
                    year: 2014,
                    title: 'Зимняя Олимпиада в Сочи XXII зимние Олимпийские игры в России'
                }
            ]
        },
        {
            id: 6,
            title: 'Наука',
            startYear: 2015,
            endYear: 2022,
            events: [
                {
                    year: 2015,
                    title: '13 сентября — частное солнечное затмение видимое в Южной Африке и части Антарктиды'
                },
                {
                    year: 2016,
                    title: 'Телескоп «Хаббл» обнаружил самую удалённую галактику, получившую обозначение GN-z11'
                },
                {
                    year: 2016,
                    title: 'Обнаружена вода в жидком виде на Марсе'
                },
                {
                    year: 2017,
                    title: 'Компания Tesla официально представила первый в мире электрический грузовик Tesla Semi'
                },
                {
                    year: 2018,
                    title: 'Запуск космического телескопа TESS для поиска экзопланет'
                },
                {
                    year: 2019,
                    title: 'Открытие нового вида динозавра в Китае с хорошо сохранившимися перьями'
                },
                {
                    year: 2020,
                    title: 'Пандемия COVID-19 стимулирует разработку мРНК-вакцин в рекордные сроки'
                },
                {
                    year: 2021,
                    title: 'Марсоход Perseverance успешно высадился на Марсе для изучения следов жизни'
                },
                {
                    year: 2022,
                    title: 'Обнаружение крупнейшей нейтронной звезды с необычайно высокой массой'
                }
            ]
        }
    ]
};
